import { useDispatch }      from 'react-redux';
import * as domainServices  from '../../domain/domains';

const useDomain = (requestedDomains) => {
    
    const reduxDispatch = useDispatch();

    const createDomain = (domain, dispatch, props, redux) => {
        let dispatchMethod = dispatch 
            ? reduxDispatch || {}
            : {};
        let d = new domainServices[domain]( props, {}, dispatchMethod, redux);
        return d;
    }

    const injectDomains = () => {
        if(requestedDomains){
            let domains     = {};

            Object.keys(requestedDomains).forEach ( domain => {
                let currentDomain = requestedDomains[domain];
                if(domainServices[domain]){
                    domains[domain.toLowerCase()] = createDomain(
                                                        domain, 
                                                        currentDomain.dispatch || true,
                                                        currentDomain.props || {},
                                                        {}
                                                    )
                }
            });
            return domains;
        }
        return {};
    }

    let injectedDomains = injectDomains();

    return injectedDomains
}

export default useDomain